var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPromote = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hover/Action-Button/Promote",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF00",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "rocket/Outlined",
    transform: "translate(3.6667, 2.3333)",
    fill: "#0A186E",
    fillRule: "nonzero",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66666667,6 C6.66666667,5.26666665 6.06666668,4.66666667 5.33333333,4.66666667 C4.59999998,4.66666667 4,5.26666665 4,6 C4,6.73333335 4.59999998,7.33333333 5.33333333,7.33333333 C6.06666668,7.33333333 6.66666667,6.73333335 6.66666667,6 Z M2.65333335,10.8333333 C2.46000002,10.2333333 2.27333319,9.53999996 2.14666653,8.83333333 L1.33333333,9.3799998 L1.33333333,11.3666662 L2.65333335,10.8333333 Z M5.33333333,-8.8817842e-16 C7.55555556,0.888888889 8.66666667,3.33333333 8.66666667,7.33333333 L10.0733337,8.27333323 C10.4466671,8.5199999 10.6666667,8.93999978 10.6666667,9.3799998 L10.6666667,13.3333333 L7.33333333,12 L3.33333333,12 L4.4408921e-16,13.3333333 L4.4408921e-16,9.3799998 C4.4408921e-16,8.93333312 0.219999909,8.5199999 0.593333244,8.27333323 L2,7.33333333 C2,3.33333333 3.11111111,0.888888889 5.33333333,-8.8817842e-16 Z M5.33333333,1.57333342 C4,2.47111119 3.33333333,4.39111116 3.33333333,7.33333333 C3.33333333,8.33333333 3.55555556,9.44444444 4,10.6666667 L6.66666667,10.6666667 C7.11111111,9.44444444 7.33333333,8.33333333 7.33333333,7.33333333 C7.33333333,4.39111116 6.66666667,2.47111119 5.33333333,1.57333342 Z M9.33333333,11.3666662 L9.33333333,9.3799998 L8.52000046,8.84000015 C8.39333379,9.54000012 8.20666697,10.2400002 8.01333364,10.8400002 L9.33333333,11.3666662 Z",
    id: "Vector"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPromote);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Promote.c2b2832338187f4dd8130735ceeea39d.svg";